import { clsx } from 'clsx';

// Sections whose content bleeds outside the content box (floating decorations) set
// `--section-bleed` to their overhang, so the gutter never gets smaller than it.
// oxlint-disable-next-line react/only-export-components
const SectionContainer = (props: React.HTMLAttributes<HTMLElement> & { gutter?: boolean }) => {
  const { gutter = true, ...rest } = props;

  return (
    <section
      {...rest}
      className={clsx(
        'flex w-full flex-col',
        gutter &&
          'px-[max(var(--section-gutter),var(--section-bleed,0px))] [--section-gutter:--spacing(6)]',
        props.className,
      )}
    />
  );
};

// oxlint-disable-next-line react/only-export-components
const SectionContent = (props: React.HTMLAttributes<HTMLElement> & { size?: 'md' | 'sm' }) => (
  <div
    {...props}
    className={clsx(
      props.className,
      'mx-auto w-full',
      { md: 'max-w-7xl', sm: 'max-w-3xl' }[props.size ?? 'md'],
    )}
  />
);

export const Section = {
  Container: SectionContainer,
  Content: SectionContent,
};
